import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { classNames } from "primereact/utils";
import { Route } from "../../models/routing.model";
import { Button } from "primereact/button";
import { useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { getLocalStorageUser } from "../../services/session/auth.service";
import { useAuth0 } from "@auth0/auth0-react";
import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { MatomoAction, MatomoCategory } from "../../models/matomo.model";
import { MatomoService } from "../../services/matomo/matomo.service";
import { ThemeService } from "../../services/theme/ThemeService.service";

const HeaderDesktop = ({ routes }: { routes: Route[] }) => {
	const { t } = useTranslation("common");
	const userPanelRef = useRef<OverlayPanel>(null);
	const { logout } = useAuth0();
	const matomo = useMatomo();

	const sendTabEvent = (routeId: string) => {
		const event = MatomoService.getTabEvent(routeId);
		if (event) {
			matomo.trackEvent({
				category: event.category,
				action: event.action,
			});
		}
	};

	return (
		<header className="topbar">
			{/* Logo */}
			<div className="topbar__logo">
				<NavLink
					to="/"
					className="topbar__logo__link"
				>
					<img
						alt={ThemeService.setIconAlt()}
						src={ThemeService.setIcon()}
					/>
				</NavLink>
			</div>

			{/* Menu options */}
			<ul className="topbar__menu">
				{/* Iterate the menu options */}
				{routes
					.filter((item) => item.routeProps.isVisible !== false)
					.map((item) => (
						<li key={`${item.routeProps.id}`}>
							<NavLink
								to={`${item.route.path}`}
								className={({ isActive }) =>
									classNames("topbar__menu__item", isActive && "is-active")
								}
								onClick={() => sendTabEvent(item.routeProps.id)}
							>
								{t(`${item.routeProps.title}`)}
							</NavLink>
						</li>
					))}
			</ul>

			<div className="topbar__user">
				<Button
					type="button"
					className="topbar__user__button"
					onClick={(e) => userPanelRef.current!.toggle(e)}
					onMouseEnter={(e) => userPanelRef.current!.toggle(e)}
				>
					<span className="p-button-label">
						<span className="topbar__user__hello">
							{t("UI_COMPONENTS.HEADER.USER")}
						</span>
						<span className="topbar__user__name">
							{getLocalStorageUser()?.firstName}
						</span>
					</span>
					<span className="p-button-icon p-button-icon-right pi pi-chevron-down"></span>
				</Button>
				<OverlayPanel
					ref={userPanelRef}
					className="topbar__user__panel"
				>
					<ul>
						<li>
							<Button
								type="button"
								label={t("UI_COMPONENTS.HEADER.LOGOUT")}
								onClick={() => {
									matomo.trackEvent({
										category: MatomoCategory.AUTHENTICATION,
										action: MatomoAction.LOGOUT,
									});
									logout({
										logoutParams: {
											returnTo: window.location.origin + "/login",
										},
									});
								}}
							/>
						</li>
					</ul>
				</OverlayPanel>
			</div>
		</header>
	);
};
export default HeaderDesktop;
